import DotSolarMap from '@/components/map/DotSolarMap';

/**
 * 각 접근방법에 대한 메서드를 정의하고 중앙 메서드를 통해 처리하도록 변경
 */
class SiteChangeManager {

  constructor() {
    this.lastProcessedSiteId = null;
    this.isProcessing = false;
  }

  /**
   * 사이트 변경을 처리하는 중앙 메서드
   * @param {Object} site - 변경될 사이트 객체
   * @param {Object} options - 옵션
   * @param {boolean} options.forceMove - 강제로 지도 이동할지 여부
   * @param {string} options.source - 변경 소스 (예: 'click', 'navigation', 'refresh')
   */
  async handleSiteChange(site, options = {}) {
    const { forceMove = false, source = 'unknown' } = options;

    if (!site || !site.id) {
      console.warn('[SiteChangeManager] 유효하지 않은 사이트:', site);
      return;
    }

    // 중복 처리 방지
    if (this.isProcessing) {
      console.log('[SiteChangeManager] 이미 처리 중입니다:', this.lastProcessedSiteId);
      return;
    }

    // 같은 사이트이고 강제 이동이 아닌 경우 스킵
    if (!forceMove && this.lastProcessedSiteId === site.id) {
      console.log('[SiteChangeManager] 같은 사이트, 스킵:', site.id);
      return;
    }

    try {
      this.isProcessing = true;
      console.log(`[SiteChangeManager] 사이트 변경 처리 시작 - ID: ${site.id}, 소스: ${source}`);

      // 지도 이동 처리
      await DotSolarMap.moveSite(site, source === 'navigation');

      // 처리 완료 후 ID 업데이트
      this.lastProcessedSiteId = site.id;

      console.log(`[SiteChangeManager] 사이트 변경 처리 완료 - ID: ${site.id}`);
    } catch (error) {
      console.error('[SiteChangeManager] 사이트 변경 처리 중 오류:', error);
    } finally {
      this.isProcessing = false;
    }
  }

  /**
   * 강제로 사이트 변경 처리 (페이지 새로고침, URL 직접 접근 등)
   */
  forceSiteChange(site) {
    return this.handleSiteChange(site, { forceMove: true, source: 'force' });
  }

  /**
   * 사이트 클릭으로 인한 변경 처리
   */
  handleSiteClick(site) {
    return this.handleSiteChange(site, { source: 'click' });
  }

  /**
   * 네비게이션으로 인한 변경 처리 (다른 페이지 갔다가 돌아옴)
   */
  handleSiteNavigation(site) {
    return this.handleSiteChange(site, { source: 'navigation' });
  }

  /**
   * 현재 처리된 사이트 ID 반환
   */
  getLastProcessedSiteId() {
    return this.lastProcessedSiteId;
  }

  /**
   * 상태 초기화 (페이지 새로고침 등)
   */
  reset() {
    this.lastProcessedSiteId = null;
    this.isProcessing = false;
  }
}

// 싱글톤 인스턴스 생성
const siteChangeManager = new SiteChangeManager();

export default siteChangeManager;
